import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/ships')({
  component: () => <Outlet />,
  staticData: {
    title: 'Ships',
  },
})
